<template>
    <card>
       <template slot="header">
          <h3 class="card-title">Employees Contact</h3>
       </template>
       <nav class="row">
          <ol class="breadcrumb arr-right bg-breadcrum">
             <li class="breadcrumb-item">
                <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
             </li>
             <li class="breadcrumb-item active">Contacts</li>
          </ol>
       </nav>
       <hr style="margin-top:-10px"/>
       <div class="col-md-12">
          <div class="row">
             <div class="col-md-12">   
                <input type="test" v-model="search" class="form-control" placeholder="Search Contact ... "> 
             </div>
          </div>
       </div>
       <hr>
       <!-- PAGINATION -->
       <b-pagination
        v-model="curentPage"
        :total-rows="contact_items.length"
        :per-page="perPage"
          aria-controls="my-table"
          align="right"
          first-text="First"
          prev-text="Prev"
          next-text="Next"
          last-text="Last"
       ></b-pagination>
       <!-- END PAGINATION -->
       <hr>
       <div class="table-responsive ">
          <table class="table table-striped table-hover " v-loading="loading">
             <thead>
                <tr>
                   <th>#</th>
                   <th >Employee Name</th>
                   <th >Personal Email</th>
                   <!-- <th >Contact Person</th> -->
                   <!-- <th >Relationship</th> -->
                   <th>Blueprint Email</th>
                   <th>Action</th>
                </tr>
             </thead>
             <tbody>
                <tr v-for="item, index in computedContacts">
                   <template v-if="item === 'no data found'">
                      <td colspan="100%">
                         <h4>  <i class="fa fa-database"></i> Empty Records ...</h4>
                      </td>
                   </template>
                   <template v-else>
                      <td>{{index + 1}}</td>
                      <td>{{item.full_name  | capitalize }}&nbsp;<i class="fa fa-mobile"></i>+{{item.contact}}</td>
                      <td>{{item.email_address}}</td>
                      <!-- <td>{{item.contact_person  | capitalize }}&nbsp;<i class="fa fa-mobile"></i>+{{item.emergency_no}}</td>
                      <td>{{item.relationship}}</td> -->
                      <td>
                         <span v-if="item.blueprint_address == null">
                         <font color="#dc3545">NOT YET REGISTER</font>
                         </span>  
                         <span v-else>
                         {{item.blueprint_address}}
                         </span>      
                      </td>
                      <td>
                         <a href="javascript:void(0)" @click="get_selected_id(item)" v-b-modal.view-contact-info class="btn  btn-xs" v-b-tooltip.hover title="click to view employee contact info"><i class="fa fa-eye "></i>View</a>   
                         <a href="javascript:void(0)" @click="get_selected_id(item)" v-b-modal.update-contact-info class="btn  btn-xs" v-b-tooltip.hover title="click to update employee contact info"><i class="fa fa-pencil"></i>Update</a> 
                      </td>
                   </template>
                </tr>
             </tbody>
          </table>
           <!-- PAGINATION NATIVE WAY -->
           <div class="row">
              <div class="col-md-6">
                  <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
              </div>
              <div class="col-md-6">
                <b-pagination
                    v-model="curentPage"
                    :total-rows="contact_items.length"
                    :per-page="perPage"
                    aria-controls="my-table"
                    align="right"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                ></b-pagination>
              </div>
           </div>
           <!-- END PAGINATION -->
       </div>
       <!-- VIEW DETAILS -->
       <b-modal id="view-contact-info"  ref="hide-contact-modal" size="xl"  hide-footer>
          <h2>Contact Info</h2>
          <hr/>
          <div class="row">
             <div class="col-md-12">
                <h4>Employee Name: <b>{{selected_user.full_name | capitalize}}</b></h4>
                <h4>Personal Number: <b><i class="fa fa-mobile"></i>{{selected_user.contact}}</b></h4>
                <h4>Personal Email: <b>{{selected_user.email_address}}</b></h4>
                <h4>Contact Person: <b><i class="fa fa-mobile"></i>{{selected_user.contact_person | capitalize}}</b></h4>
                <h4>Relationship: <b>{{selected_user.relationship}}</b></h4>
                <h4>Blueprint Email: 
                   <span v-if="selected_user.blueprint_address == null">
                   <font color="#dc3545">NOT YET REGISTER</font>
                   </span> 
                   <span v-else> 
                   <b>{{selected_user.blueprint_address}}</b>
                   </span>   
                </h4>
             </div>
          </div>
       </b-modal>
       <!-- ADD NEW ITEM -->
       <b-modal id="update-contact-info"  ref="hide-contact-modal" size="xl"   title="Update Contact"  hide-footer>
          <h3>{{selected_user.full_name | capitalize}}</h3>
          <div class="row">
             <div class="col-md-6">
                <div class="form-group">
                   <label>Personal No. :</label>
                   <input type="tel" v-mask="['####-#######']"  class="form-control" v-model="selected_user.contact"/>
                </div>
                <div class="form-group">
                   <label>Personal Email. :</label>
                   <input type="email" v-model="selected_user.email_address" class="form-control" />
                </div>
                <div class="form-group">
                   <label>Company Email. :</label>
                   <input type="email" v-model="selected_user.blueprint_address"  class="form-control" />
                </div>
             </div>
             <div class="col-md-6">
                <div class="form-group">
                   <label>Emergency No. :</label>
                   <input type="tel" v-mask="['####-#######']"  class="form-control" v-model="selected_user.emergency_no"/>
                </div>
                <div class="form-group">
                   <label>Contact Person :</label>
                   <input type="text" class="form-control"  v-model="selected_user.contact_person" pattern="[A-Za-z ]{1,32}"/>
                </div>
                <div class="form-group">
                   <label>Relationship : </label>
                   <select class="form-control" v-model="selected_user.relationship">
                      <option disabled value="">-- Please select one --</option>
                      <option value="Mother">Mother</option>
                      <option value="Father">Father</option>
                      <option value="Father">Daughter</option>
                      <option value="Son">Son</option>
                      <option value="Sister">Sister</option>
                      <option value="Brother">Brother</option>
                      <option value="Aunt">Aunt</option>
                      <option value="Uncle">Uncle</option>
                      <option value="Niece">Niece</option>
                      <option value="Nephew">Nephew</option>
                      <option value="Sibling">Sibling</option>
                      <option value="Sibling">Guardian</option>
                      <option value="Live in Partner">Live in Partner</option>
                      <option value="Cousin(Female)">Cousin(Female)</option>
                      <option value="Cousin(Male)">Cousin(Male)</option>
                      <option value="Grandmother">Grandmother</option>
                      <option value="Brother">Grandfather</option>
                      <option value="Granddaughter">Granddaughter</option>
                      <option value="Grandson">Grandson</option>
                      <option value="Stepsister">Stepsister</option>
                      <option value="Stepbrother">Stepbrother</option>
                      <option value="Stepmother">Stepmother</option>
                      <option value="Stepfather">Stepfather</option>
                      <option value="Girlfreind">Girlfreind</option>
                      <option value="Boyfreind">Boyfreind</option>
                      <option value="Wife">Wife</option>
                      <option value="Husband">Husband</option>
                   </select>
                </div>
             </div>
             <div class="col-md-12">
                <hr/>
             </div>
             <div class="col-md-6"></div>
             <div class="col-md-6">
                <div class="form-group">
                   <button class="btn btn-info float-right" @click="update_contact"><i class="fa fa-save"></i> Save Changes</button><br/><br/>
                </div>
             </div>
          </div>
       </b-modal>
       <!-- If Lost Connection on Server -->   
       <template v-if="display_indicator === 1">
          <center>
             <br/><br/>
             <img  src="/static/img/warning.png"  width="225" height="190">
             <h1>You've lost your network connection</h1>
             <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
             <br/><br/>
          </center>
       </template>
    </card>
 </template>
<script>
 /* eslint-disable */
  import Card from 'src/components/UIComponents/Cards/Card.vue'  
  export default {
  components: {
    Card
  },
  data() {
    return {
      contact_items: [],
      personale_no: "",
      emergency_no: "",
      relationship: "",
      search: "",
      selected_user: "",
      loading: true,
      //Indicator
      display_indicator: "",
      //PAGINATION
      perPage: 200,
      curentPage:1
    };
  },
  created: function() {
    this.get_contact();
  },
  methods: {
    get_contact() {
      axios
        .get("api/contacts")
        .then(response => {
          this.contact_items = response.data;
          this.display_indicator = 2;
          this.loading = false
        })
        .catch(e => {
          console.log(e.response);
          this.display_indicator = 1;
        });
    },
    get_selected_id(item) {
      this.selected_user = item;
    },

    update_contact() {
      axios
        .post(
          "api/contacts/update/" + this.selected_user.id,
          {
            contact: this.selected_user.contact,
            contact_person: this.selected_user.contact_person,
            emergency_no: this.selected_user.emergency_no,
            email_address: this.selected_user.email_address,
            blueprint_address: this.selected_user.blueprint_address,
            relationship: this.selected_user.relationship
          }
        )
        .then(response => {
          this.$swal({
            type: "success",
            title: "Save",
            text: "You successfully save",
            showConfirmButton: false,
            timer: 2000
          });
          this.get_contact();
          this.$refs["hide-contact-modal"].hide();
          console.log(response.data);
        })
        .catch(e => {
          console.log(e.response);
        });
    }
  },
  computed: {
    total_item(){ return this.contact_items.length }, 
    computedContacts() {
      let filtered = this.contact_items;
       // USE IN PAGINATION 
       let start = (this.curentPage-1) * this.perPage
       let end = this.curentPage * this.perPage
       filtered = filtered.slice(start, end)

      if (filtered.length > 0) {
        if (this.search) {
          filtered = filtered.filter(
            item => item.full_name.toLowerCase().indexOf(this.search) > -1
          );
          return filtered;
        }
      }
      return filtered;
    }
  },

};
</script>
<style>
       .bg-breadcrum{
            background:#fff;
         }
         .link-default{
            color: #666;
        }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-contact-info/todo-contact-info.vue